exports = module.exports = require("../../../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".gz-confirm-dialog-container .gz-readonly .label{font-weight:700}.gz-confirm-dialog-container .gz-readonly .label:after{content:\":\"}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../~/css-loader!../~/sass-loader!../~/@printos/gazelle/src/components/confirm/confirm-dialog.scss
// module id = 104
// module chunks = 0